import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Container, Divider, Grid, Link, Typography, useTheme } from '@mui/material';
import SvgIconStyle from '@components/SvgIconStyle';
import SocialsButton from '~/components/SocialsButton';
import { useStyles } from './styles';
import { SOCIAL_LINKS } from '~/config';

const FooterBlock: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <>
      <Divider sx={styles.divider} />
      <Container sx={styles.container}>
        <Grid container sx={styles.gridContainer}>
          <Grid item sx={styles.leftColumn}>
            <SvgIconStyle src="/icons/ic_logo.svg" sx={styles.logoFooter} />
            {/* <Typography variant="body2" sx={styles.aboveIconsText}>
              {t('landing.lorem_ipsum')}
            </Typography> */}
            <SocialsButton links={SOCIAL_LINKS} sx={styles.socialButtons} />
          </Grid>
          <Grid item sx={styles.rightColumn}>
            <Grid item sx={styles.legalColumn}>
              <Typography variant="overline">{t('landing.legal')}</Typography>
              <Link href="https://www.bigpurpledot.com/terms">
                <Typography variant="body2" sx={styles.termsLink}>
                  {t('landing.terms')}
                </Typography>
              </Link>
              <Link href="https://www.bigpurpledot.com/privacy">
                <Typography variant="body2" sx={styles.privacyLink}>
                  {t('landing.privacy')}
                </Typography>
              </Link>
            </Grid>

            <Grid item sx={styles.contactColumn}>
              <Typography variant="overline" sx={styles.legalText}>
                {t('landing.contact')}
              </Typography>
              <Typography variant="body2" sx={styles.termsLink}>
                {t('landing.phone')}
              </Typography>
              <Typography variant="body2" sx={styles.privacyLink}>
                {t('landing.address')}
              </Typography>
            </Grid>
          </Grid>
          <Typography variant="body2" sx={styles.rightsReservedText}>
            {t('landing.rights_reserved')}
          </Typography>
        </Grid>
      </Container>
    </>
  );
};

export default FooterBlock;
